import React, { useState, useEffect } from 'react'
import Carousel from 'react-multi-carousel'
import { responsive } from 'components/brands/landingPage/brandDataHelper'
import BlogCard from 'components/blog/card/blogCard'
import './homeBlogPosts.sass'
import '../../locations/locations.css'
import 'react-multi-carousel/lib/styles.css'
import butter from 'components/elements/butterClient/butterClient'

const HomeBlogPosts = (props) => {
  const { isMobile } = props
  const [blogPosts, setBlogPosts] = useState([])

  const fetchBlogPosts = async () => {
    let butterParams = {
      page: 1,
      page_size: 3,
      exlude_body: true,
      order: "desc"
    }

    try {
      const resp = await butter.post.list(butterParams)
      setBlogPosts(resp.data.data)
    } catch (error) {
    }
  }

  useEffect(() => {
    fetchBlogPosts()
  }, [])

  const CustomRightArrow = ({ onClick }) => (
    <button className="arrow carousel-right" onClick={onClick}>
      <i className="fa fa-angle-right" style={{ fontSize: "32px" }} />
    </button>
  )

  const CustomLeftArrow = ({ onClick }) => (
    <button className="arrow carousel-left" onClick={onClick}>
      <i className="fa fa-angle-left" style={{ fontSize: "32px" }} />
    </button>
  )

  return (
    <React.Fragment>
      {blogPosts.length > 0 && isMobile && (
        <Carousel
          autoPlay={false}
          responsive={responsive}
          infinite={true}
          className='blog-post-carousel'
        >
          {blogPosts?.map((post, i) => (
            <BlogCard 
              post={post}
              showSummary={true}
              isMobile={isMobile}
            />
          ))}
        </Carousel>
      )}
      {blogPosts.length > 0 && !isMobile && (
        <div className='homepage-blogcard-wrapper'>
          {
            blogPosts.map((post, index) => (
              <BlogCard 
                post={post}
                key={index}
                showSummary={true}
                isMobile={isMobile}
                headerLevel={'h3'}
              />
            ))
          }
        </div>
      )}
    </React.Fragment>
  )
}

export default HomeBlogPosts